export default __webpack_public_path__ + "static/mobile-banner-949575471b46bcb24440bd9840836680.png";